import { render, staticRenderFns } from "./ProgrammaticData.vue?vue&type=template&id=536834cd&scoped=true&lang=pug"
import script from "./ProgrammaticData.js?vue&type=script&lang=js&external"
export * from "./ProgrammaticData.js?vue&type=script&lang=js&external"
import style0 from "./ProgrammaticData.vue?vue&type=style&index=0&id=536834cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536834cd",
  null
  
)

export default component.exports